
export default async function( token, environment, identity ) {

    try {
        const response = await fetch( `https://${ environment && environment !== 'prod' ? `${ environment }.` : '' }api.biw.cloud/solutionapi/services/v1/solutions/search?identity=${ identity }`, {
            method: 'GET',
            headers: {
                'content-type': 'application/json',
                'authorization': `Bearer ${ token }`
            }
        } );
        if ( response.ok ) {
            const solution = await response.json();
            return { success: true, solution };
        } else {
            return { success: false };
        }
    } catch ( error ) {
        return { success: false };
    }
}
